export const shortAddress = (value) => {
    if (value) {
        return `${value.slice(0, 5)}...${value.slice(-4)}`.toUpperCase();
    }
}

export const getTextColorByROI = (value) => {
    if (value) {
        if (value < 100) {
            return "text__danger"
        } else if (value > 80 && value <= 100) {
            return "L";
        } else if (value > 101) {
            return "text__success"
        }
    }
}

export const getHpChest = (value) => {
    if (value < 25) {
        return "-10%";
    } else if (value > 25 && value < 50) {
        return "-5%";
    } else if (value > 51 && value < 100) {
        return "Normal";
    } else if (value > 101 && value < 200) {
        return "+10%";
    } else if (value > 201 && value < 300) {
        return "+20%";
    } else if (value > 301 && value < 400) {
        return "+30%";
    } else if (value > 401 && value < 500) {
        return "+40%";
    } else if (value > 500) {
        return "+50%";
    }
}

export const getTextColorByHpChest = (value) => {
    if (value) {
        if (value < 51) {
            return "text__success"
        } else if (value > 51 && value <= 100) {
            return "L";
        } else if (value > 101) {
            return "text__danger"
        }
    }
}
